<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    width="100%"
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-text>
          <simple-google-autocomplete
            id="daMapz"
            v-model="address_string"
            outlined dense persistent-placeholder hide-details
            label="Business Location"
            autocomplete="business_location"
            @placechanged="updateAddressData"
            country="us"
            :rules="[required]"
            class="mb-2"
          />
          <l-map ref="theMap" style="height: 220px" :zoom="zoom" :center="center" 
            @ready="mapReady" class="mb-4"
          >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker :lat-lng="center" />
            <l-circle :lat-lng="center" :radius="radius" color="green" />
          </l-map>
          <CoverageAreaSelect 
            outlined dense persistent-placeholder persistent-hint
            label="Coverage Area (miles)" 
            v-model="coverage_radius"
            hint="How far will you drive for a customer?"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { latLng } from "leaflet"
  import { LCircle, LMarker, LMap, LTileLayer } from 'vue2-leaflet'
  import { required } from '@/lib/validations'
  import CoverageAreaSelect from '@/components/inputs/CoverageAreaSelect';
  import { mapActions} from 'vuex'
  import { ActivatorButton } from '@/components/pages'

  export default {
    name: 'ProContactDialog',

    components: { ActivatorButton, LCircle, LMarker, LMap, LTileLayer, CoverageAreaSelect },

    props: ['pro'],

    data() {
      return {
        dialogVisible: false,

        zoom: 8,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

        address_string: '',

        place_id: '',
        latitude: 30.2672,
        longitude: -97.7431,
        street: '',
        city: '',
        state: '',
        zipcode: '',
        coverage_radius: 20,

        // validation rules
        required,
      };
    },

    computed: {
      rand_id() {
        return 'gac-id-' + Math.floor(Math.random()*10000)
      },

      center() {
        return latLng(this.latitude, this.longitude)
      },

      radius() { 
        // in meters
        return this.coverage_radius * 1609.34
      },
    },


    watch: {
      dialogVisible(visible) {
        if( visible ) {
          const address = this.pro.address
          
          this.address_string = `${address.street}, ${address.city}, ${address.state}, ${ address.zipcode }`
          
          this.place_id = address.place_id
          this.latitude = address.latitude || this.latitude
          this.longitude = address.longitude || this.longitude
          this.street = address.street
          this.city = address.city
          this.state = address.state
          this.zipcode = address.zipcode

          this.coverage_radius = this.pro.coverage_radius
        }
      },
    },

    methods: {
      ...mapActions('auth', ['updateMe']),
      
      close() {
        this.dialogVisible = false
      },

      mapReady() {
        // vu2-leaflet doesnt love v-dialog, this is the fix
        this.$refs.theMap.mapObject.invalidateSize()
      },

      updateAddressData(addressData) {
        this.place_id = addressData.place_id
        this.latitude = addressData.latitude
        this.longitude = addressData.longitude
        this.street = addressData.name
        this.city = addressData.locality
        this.state = addressData.administrative_area_level_1
        this.zipcode = addressData.postal_code
      },

      async submitClick() {
        const payload = {
          address: {
            place_id: this.place_id,
            coords: `POINT(${this.longitude} ${this.latitude})`,
            street: this.street,
            city: this.city,
            state: this.state,
            zipcode: this.zipcode,
          },
          coverage_radius: this.coverage_radius,
        }

        const result = await this.updateMe(payload)
        if (result.ok) {
          this.close()
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>